// extracted by mini-css-extract-plugin
module.exports = {"marque":"client_marque__JLgmr","marqueTrack":"client_marqueTrack__0fEse","marquee":"client_marquee__3vs2Z","marqueInner":"client_marqueInner__vvpbb"};